import Utils from '@/utils/utils';
import cookies from '@/utils/cookie';
import { officialAccountsId as defaultOfficialAccountsId  } from '@/config';

const TURN_APP_TYPES = new Set(['VOTE', 'ITEM_BANK', 'RECITE_WORD', 'KK', 'NAIRE',
  'DA', 'SPECIAL', 'BM', 'EF', 'TUTOR', 'ZSCORE', 'GROUP', 'BOOKCARD', 'INTERACT',
  'LIVE', 'SCHEDULE', 'LIVE_TIMETABLE', 'WISH', 'CLOCK', 'DRAW', 'TEST', 'AUDIO_MAGIC',
  'TEACH_RESOURCE', 'COURSE_WARE', 'STROKE_ORDER', 'WORD_DICTATION', 'MEMBER', 'ENGLISH_WALKMAN', 'SUBJECTNOTE', 'MATCH_LISTEN', 'PBSTORY', 'BOOK_CLICK', 'ORAL_EVALUATION', 'ARTICLE_READING', 'COLD_KNOWLEDGE']);

export const getAppRelativeUrlByType = (data = {}, query = {}) => {
  const { typeCode = '', appId = 0 } = data;
  const { sceneId, adviserId } = cookies.get();
  let queryStr = Utils.formatQuery2QueryStr(Object.assign({
    adviserId: adviserId,
    sceneId: sceneId
  }, query));
  // 小应用
  if(TURN_APP_TYPES.has(typeCode)) {
    const appType = typeCode2AppType(typeCode);
    return `/application/${appId}/redirect/${appType}${queryStr}`;
  } else if(typeCode === 'VOICE_MSG') {         // 语音留言
    return `/application/${appId}/voicemail${queryStr}`;
  } else if(typeCode === 'ACTIVITY') {         // 分享互动
    return `/application/${appId}/propaganda${queryStr}`;
  } else if(['VIDEO', 'VIDEO_COURSE'].includes(typeCode)) { // 视频课
    return `/application/${appId}/video${queryStr}`;
  } else if(['AUDIO'].includes(typeCode)) { // 视频课
    return `/application/${appId}/audio${queryStr}`;
  } else if(typeCode === 'EBOOK') {  // 电子书应用
    return `/application/${appId}/ebook${queryStr}`;
  } else if(typeCode === 'BOOK_ORDER') { //图书订购
    return `/application/${appId}/bookOrder${queryStr}`;
  } else {                                    // 普通应用详情
    return `/application/${appId}/display${queryStr}`;
  }
};

//直接跳转小应用
export const getAppRedirectUrlByType = (data = {}, query = {}, url) => {
  const { typeCode = '', appId = 0, channelId: appChannelId, officialAccountsId: appOfficialAccountsId } = data;
  // 防止获取临时用户 officialAccountsId
  const officialAccountsId = appOfficialAccountsId || defaultOfficialAccountsId;
  let { channelId, sceneId, adviserId } = cookies.get();
  channelId = appChannelId || channelId;
  let queryStr = Utils.formatQuery2QueryStr(Utils.searchAssign(Object.assign({
    adviserId: adviserId,
    sceneId: sceneId
  }, query)));
  // 小应用
  const appType = typeCode2AppType(typeCode);
  const appUrl = url || typeCode2AppUrl(typeCode);
  if(TURN_APP_TYPES.has(typeCode)) {
    return `/${appType}/W${officialAccountsId}/C${channelId}/A${appId}/${appUrl}${queryStr}`;
  } else {
    //客户端
    const appRelativeUrl = getAppRelativeUrlByType(data, query);
    return `/W${officialAccountsId}/C${channelId}${appRelativeUrl}`;
  }
};

// 根据后端应用类型转换成前端小应用标识
export const typeCode2AppType = (typeCode = '') => {
  let appType = String(typeCode).toLowerCase();
  switch (typeCode) {
    // 投票
    case 'VOTE':
      appType = 'vt';
      break;
    // 题库
    case 'ITEM_BANK':
      appType = 'pretest';
      break;
    // 背单词
    case 'RECITE_WORD':
      appType = 'wd';
      break;
    // 扫扫看
    case 'KK':
      appType = 'kk';
      break;
    // 问卷调查
    case 'NAIRE':
      appType = 'qn';
      break;
    // 数据采集
    case 'DA':
      appType = 'qn';
      break;
    // 专题
    case 'SPECIAL':
      appType = 'st';
      break;
    // 报名
    case 'BM':
      appType = 'mt';
      break;
    // 教育表格
    case 'EF':
      appType = 'tb';
      break;
    // 1对1辅导
    case 'TUTOR':
      appType = 'cc';
      break;
    //标准分
    case 'ZSCORE':
      appType = 'zscore';
      break;
    //圈子
    case 'GROUP':
      appType = 'group';
      break;
    //读书卡片
    case 'BOOKCARD':
      appType = 'card';
      break;
    //互动墙
    case 'INTERACT':
      appType = 'interact';
      break;
    //直播
    case 'LIVE':
    case 'SCHEDULE':
    case 'LIVE_TIMETABLE':
      appType = 'live';
      break;
    //直播
    case 'WISH':
      appType = 'wish';
      break;
    //打卡
    case 'CLOCK':
      appType = 'clock';
      break;
    case 'TEST':
      appType = 'tt';
      break;
    //  抽奖
    case 'DRAW':
      appType = 'luck';
      break;
    //  伴读魔法箱
    case 'AUDIO_MAGIC':
      appType = 'magic';
      break;
    //教辅资料包
    case 'TEACH_RESOURCE':
      appType = 'tr';
      break;
    //  课件
    case 'COURSE_WARE':
      appType = 'cw';
      break;
    //笔顺动图
    case 'STROKE_ORDER':
      appType = 'pen';
      break;
    //  生词听写
    case 'WORD_DICTATION':
      appType = 'dictation';
      break;
    //  开通会员
    case 'MEMBER':
      appType = 'member';
      break;
    case 'ENGLISH_WALKMAN':
      appType = 'wm';
      break;
    case 'SUBJECTNOTE':
      appType = 'subject';
      break;
    case 'MATCH_LISTEN':
      appType = 'mv';
      break;
    case 'PBSTORY':
      appType = 'pbstory';
      break;
    case 'BOOK_CLICK':
      appType = 'clickread';
      break;
    case 'ORAL_EVALUATION':
      appType = 'speak';
      break;
    case 'ARTICLE_READING':
      appType = 'ar';
      break;
    case 'COLD_KNOWLEDGE':
      appType = 'cold';
      break;
  }
  return appType;
};

const typeCode2AppUrl = (typeCode = '') => {
  let appUrl = 'list';
  switch (typeCode) {
    // 题库
    case 'ITEM_BANK':
      appUrl = '';
      break;
    // 扫扫看
    case 'KK':
      appUrl = 'questionnaire';
      break;
    // 专题
    case 'SPECIAL':
      appUrl = 'special';
      break;
    //标准分
    case 'ZSCORE':
      appUrl = 'search';
      break;
    //圈子
    case 'GROUP':
      appUrl = 'info';
      break;
    //读书卡片 互动墙
    case 'BOOKCARD':
    case 'INTERACT':
    case 'WISH':
      appUrl = 'home';
      break;
    case 'LIVE':
    case 'SCHEDULE':
    case 'LIVE_TIMETABLE':
      appUrl = 'liveinfo';
      break;
    case 'CLOCK':
      appUrl = 'custom/sign';
      break;
    case 'TEST':
      appUrl = 'char/info';
      break;
    //  抽奖
    case 'DRAW':
      appUrl = 'luckpage';
      break;
    //  伴读魔法箱
    case 'AUDIO_MAGIC':
      appUrl = 'box';
      break;
    //教辅资料包
    case 'TEACH_RESOURCE':
      appUrl = 'packagelist';
      break;
    //  课件
    case 'COURSE_WARE':
      appUrl = 'list';
      break;
    //笔顺动图
    case 'STROKE_ORDER':
      appUrl = 'list';
      break;
    //  生词听写
    case 'WORD_DICTATION':
      appUrl = 'list';
      break;
    //  开通会员
    case 'MEMBER':
      appUrl = 'info';
      break;
    // 英语随身听
    case 'ENGLISH_WALKMAN':
      appUrl = 'player';
      break;
    // 错题本
    case 'SUBJECTNOTE':
      appUrl = 'catalog';
      break;
    case 'MATCH_LISTEN':
      appUrl = 'listen';
      break;
    case 'PBSTORY':
      appUrl = 'list';
      break;
    case 'BOOK_CLICK':
      appUrl = 'home';
      break;
    case 'ORAL_EVALUATION':
      appUrl = 'info';
      break;
    case 'ARTICLE_READING':
      appUrl = 'reading';
      break;
    case 'COLD_KNOWLEDGE':
      appUrl = 'cold';
      break;
  }
  return appUrl;
};

// 根据路由判断当前是否为app
export const isApp = (location = {}, params = {}) => {
  const { pathname, query = {}} = location;
  const { appId = 0 } = params;
  const { type = '' } = query;
  return !(appId <= 0                                       // 应用id
    || ['book'].some((item) => pathname.includes(item))       // 读书卡片
    || ['book'].some((item) => type === item)) || pathname.includes('ebook');               // 读书卡片跳资源预览
};

export const appTypeList = [
  {
    url: '/rayh5/learning/study',
    typeCode: 'LEARNING_REPORT'
  }
];

/**
 * CastileMan 2019-04-08：
 * 此页面应用跳转均不再继续维护，后续会逐步移除
 * 相关跳转配置请在 /src/utils/redirector.js 进行设置
 * **/
